import React from 'react';
import '../styles/BrandIcon.css';

// Renders a brand/org icon with a white backing so transparent PNGs/SVGs
// don't pick up whatever surface color they're placed on. Sizing, radius,
// and layout stay controlled by the className passed in from each call site.
const BrandIcon = ({ src, alt = '', className = '', style, ...rest }) => {
  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt}
      className={`brand-icon${className ? ` ${className}` : ''}`}
      style={style}
      {...rest}
    />
  );
};

export default BrandIcon;
